import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOOExoViewRow = (props) => {
    const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyRequired1" param2="qtyRequired2" format="a" />
                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "showCost" }} >
                    <li className="uiColumnRight uiColumn90">
                        <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "resUnitCost" }} />
                    </li>
                    <li className="uiColumnRight uiColumn90">
                        <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "processUnitCost" }} />
                    </li>
                    <li className="uiColumnRight uiColumn90">
                        <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "ohUnitCost" }} />
                    </li>
                    <li className="uiColumnRight uiColumn90">
                        <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "totalUnitCost" }} />
                    </li>
                </FormWrapper>
                <li className="uiColumnCenter uiColumn70 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "edit",  
                            paramName: "editBtn",
                            actionParam: {pathKey: "OEXO"}, containerKey: "popup" }}
                            className="" ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="clear"
                            onlyIcon={true}
                            tooltip="Delete"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "del",  
                            paramName: "delBtn",
                            actionParam: {pathKey: "OEXO"}, containerKey: "row" }}
                            className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdIOOExoViewRow
